import { DatapointPerformancePeriodEnum } from "api/ux/src";
export var DetailsPanelType;
(function (DetailsPanelType) {
    DetailsPanelType[DetailsPanelType["WidgetFilter"] = 0] = "WidgetFilter";
    DetailsPanelType[DetailsPanelType["DashboardFilter"] = 1] = "DashboardFilter";
    DetailsPanelType[DetailsPanelType["DashboardAssistant"] = 2] = "DashboardAssistant";
    DetailsPanelType[DetailsPanelType["DocumentServicefilters"] = 3] = "DocumentServicefilters";
    DetailsPanelType[DetailsPanelType["ChangeBenchmark"] = 4] = "ChangeBenchmark";
    DetailsPanelType[DetailsPanelType["CffChangeModal"] = 5] = "CffChangeModal";
})(DetailsPanelType || (DetailsPanelType = {}));
export var ChartSelectSlotProps;
(function (ChartSelectSlotProps) {
    ChartSelectSlotProps["hidden"] = "hidden";
    ChartSelectSlotProps["left"] = "left";
    ChartSelectSlotProps["right"] = "right";
})(ChartSelectSlotProps || (ChartSelectSlotProps = {}));
export var ChartSelectValueDataLabelsVisibility;
(function (ChartSelectValueDataLabelsVisibility) {
    ChartSelectValueDataLabelsVisibility["showDataLabels"] = "showDataLabels";
    ChartSelectValueDataLabelsVisibility["showDataAxisValues"] = "showDataAxisValues";
})(ChartSelectValueDataLabelsVisibility || (ChartSelectValueDataLabelsVisibility = {}));
export var VariationFormat;
(function (VariationFormat) {
    VariationFormat["esgVariation"] = "esgVariation";
    VariationFormat["simpleChange"] = "simpleChange";
    VariationFormat["simplePercentage"] = "simplePercentage";
    VariationFormat["percentageOfChange"] = "percentageOfChange";
})(VariationFormat || (VariationFormat = {}));
export var VariationType;
(function (VariationType) {
    VariationType["first"] = "first";
    VariationType["secondToLast"] = "secondToLast";
    VariationType["toLast"] = "toLast";
})(VariationType || (VariationType = {}));
export var DataGranularity;
(function (DataGranularity) {
    DataGranularity["quarterly"] = "EOQ";
    DataGranularity["yearly"] = "EOY";
    DataGranularity["yearOverYear"] = "YOY";
})(DataGranularity || (DataGranularity = {}));
export var InspectDatapointValueTranscoder;
(function (InspectDatapointValueTranscoder) {
    InspectDatapointValueTranscoder["date"] = "date";
    InspectDatapointValueTranscoder["UNGlobalPrinciples"] = "UNGlobalPrinciples";
})(InspectDatapointValueTranscoder || (InspectDatapointValueTranscoder = {}));
export var componentPropsPatcher;
(function (componentPropsPatcher) {
    componentPropsPatcher["addCustomFieldsToGridProps"] = "addCustomFieldsToGridProps";
    componentPropsPatcher["addCustomFieldsToSelValues"] = "addCustomFieldsToSelValues";
    componentPropsPatcher["moveSelectedGroupByColumns"] = "moveSelectedGroupByColumns";
    componentPropsPatcher["addSelectedGroupByColumns"] = "addSelectedGroupByColumns";
    componentPropsPatcher["replaceDimensionsWithSelectedGroupByColumns"] = "replaceDimensionsWithSelectedGroupByColumns";
    componentPropsPatcher["setupPublicIndicesContext"] = "setupPublicIndicesContext";
    componentPropsPatcher["setupGenericIndicesContext"] = "setupGenericIndicesContext";
    componentPropsPatcher["setupContextObjective"] = "setupContextObjective";
    componentPropsPatcher["removePreqinDefaultGroup"] = "removePreqinDefaultGroup";
    componentPropsPatcher["setupCffModelIdContext"] = "setupCffModelIdContext";
    componentPropsPatcher["filterCffModelMeasures"] = "filterCffModelMeasures";
    componentPropsPatcher["setupCffModalFilters"] = "setupCffModalFilters";
    componentPropsPatcher["setupBenchmarkIdContext"] = "setupBenchmarkIdContext";
    componentPropsPatcher["filterCffHistoricalMeasures"] = "filterCffHistoricalMeasures";
    componentPropsPatcher["filterCffHistoricalLabels"] = "filterCffHistoricalLabels";
    componentPropsPatcher["filterFundLevelAxesForPacing"] = "filterFundLevelAxesForPacing";
})(componentPropsPatcher || (componentPropsPatcher = {}));
export var ConditionalVisibility;
(function (ConditionalVisibility) {
    ConditionalVisibility[ConditionalVisibility["myPositionsOnly"] = 1] = "myPositionsOnly";
    ConditionalVisibility[ConditionalVisibility["wholeFundOnly"] = 2] = "wholeFundOnly";
})(ConditionalVisibility || (ConditionalVisibility = {}));
export var WidgetMode;
(function (WidgetMode) {
    WidgetMode["Normal"] = "normal";
    WidgetMode["Comparison"] = "comparison";
})(WidgetMode || (WidgetMode = {}));
export var SortByTypes;
(function (SortByTypes) {
    SortByTypes["Name"] = "name";
    SortByTypes["Value"] = "value";
})(SortByTypes || (SortByTypes = {}));
export var DisplayValueType;
(function (DisplayValueType) {
    DisplayValueType["Percent"] = "percent";
    DisplayValueType["Numeral"] = "numeral";
})(DisplayValueType || (DisplayValueType = {}));
export var DataScale;
(function (DataScale) {
    DataScale["unit"] = "Unit";
    DataScale["million"] = "Million";
    DataScale["billion"] = "Billion";
})(DataScale || (DataScale = {}));
export var ChartSelectValueFormatKind;
(function (ChartSelectValueFormatKind) {
    ChartSelectValueFormatKind[ChartSelectValueFormatKind["value"] = 0] = "value";
    ChartSelectValueFormatKind[ChartSelectValueFormatKind["percent"] = 1] = "percent";
    ChartSelectValueFormatKind[ChartSelectValueFormatKind["multiple"] = 2] = "multiple";
    ChartSelectValueFormatKind[ChartSelectValueFormatKind["amount"] = 3] = "amount";
    ChartSelectValueFormatKind[ChartSelectValueFormatKind["compact"] = 4] = "compact";
    ChartSelectValueFormatKind[ChartSelectValueFormatKind["compactAmount"] = 5] = "compactAmount";
    ChartSelectValueFormatKind[ChartSelectValueFormatKind["esg"] = 6] = "esg";
    ChartSelectValueFormatKind[ChartSelectValueFormatKind["string"] = 7] = "string";
    ChartSelectValueFormatKind[ChartSelectValueFormatKind["date"] = 8] = "date";
    ChartSelectValueFormatKind[ChartSelectValueFormatKind["boolean"] = 9] = "boolean";
    ChartSelectValueFormatKind[ChartSelectValueFormatKind["area"] = 10] = "area";
    ChartSelectValueFormatKind[ChartSelectValueFormatKind["dateTime"] = 11] = "dateTime";
    ChartSelectValueFormatKind[ChartSelectValueFormatKind["unit"] = 12] = "unit";
    ChartSelectValueFormatKind[ChartSelectValueFormatKind["entity"] = 13] = "entity";
})(ChartSelectValueFormatKind || (ChartSelectValueFormatKind = {}));
export var DataGranularityType;
(function (DataGranularityType) {
    DataGranularityType["Value"] = "Value";
    DataGranularityType["Variation"] = "Variation";
})(DataGranularityType || (DataGranularityType = {}));
export var SectionModule;
(function (SectionModule) {
    SectionModule["CFF"] = "CFF";
    SectionModule["ESG"] = "ESG";
    SectionModule["INFRA"] = "INFRA";
    SectionModule["PD"] = "PD";
    SectionModule["PE"] = "PE";
    SectionModule["RE"] = "RE";
    SectionModule["RISK"] = "RISK";
    SectionModule["RISKBENCHMARKING"] = "RISKBENCHMARKING";
})(SectionModule || (SectionModule = {}));
export var InspectDataPeriods;
(function (InspectDataPeriods) {
    InspectDataPeriods[InspectDataPeriods["AllPeriods"] = -1] = "AllPeriods";
    InspectDataPeriods[InspectDataPeriods["CurrentPeriod"] = 1] = "CurrentPeriod";
    InspectDataPeriods[InspectDataPeriods["VariationPeriod"] = 2] = "VariationPeriod";
})(InspectDataPeriods || (InspectDataPeriods = {}));
export var TimePeriods;
(function (TimePeriods) {
    TimePeriods["SpecifiedPeriodToAsOfDate"] = "SpecifiedPeriodToAsOfDate";
    TimePeriods["LastSpecifiedPeriod"] = "LastSpecifiedPeriod";
    TimePeriods["FromDateToDate"] = "FromDateToDate";
})(TimePeriods || (TimePeriods = {}));
export var FromPeriods;
(function (FromPeriods) {
    FromPeriods["Inception"] = "Inception";
    FromPeriods["Year"] = "Year";
})(FromPeriods || (FromPeriods = {}));
export var LastPeriods;
(function (LastPeriods) {
    LastPeriods["Months"] = "Months";
    LastPeriods["Quarters"] = "Quarters";
    LastPeriods["Years"] = "Years";
})(LastPeriods || (LastPeriods = {}));
const tenorOptionsMap = {
    Itd: DatapointPerformancePeriodEnum.Itd,
    Ytd: DatapointPerformancePeriodEnum.Ytd,
    customDateRange: "CustomDateRange",
    fiveYears: DatapointPerformancePeriodEnum.FiveYears,
    oneMonth: "OneMonth",
    oneQuarter: DatapointPerformancePeriodEnum.OneQuarter,
    oneYear: DatapointPerformancePeriodEnum.OneYear,
    sixMonths: DatapointPerformancePeriodEnum.SixMonths,
    tenYears: DatapointPerformancePeriodEnum.TenYears,
    threeYears: DatapointPerformancePeriodEnum.ThreeYears,
    twoYears: DatapointPerformancePeriodEnum.TwoYears
};
export { tenorOptionsMap as TenorOptions };
